export default {
  tariffCodes: [],
  tariffCode: undefined,
};
